const ALLOWED_IMAGE_TYPES = ['image/png', 'image/jpeg', 'image/jpg'];
const ALLOWED_IMAGE_TYPE_STRING = ALLOWED_IMAGE_TYPES.join(', ');

export { ALLOWED_IMAGE_TYPES, ALLOWED_IMAGE_TYPE_STRING };
